var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.8,
    height: 10.346,
    viewBox: "0 0 15.8 10.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list_FILL0_wght400_GRAD0_opsz48",
    d: "M9.731,15.552V14H21.8v1.552Zm0,4.4V18.4H21.8v1.552Zm0,4.4V22.794H21.8v1.552ZM6.658,15.552a.592.592,0,0,1-.472-.22.922.922,0,0,1,0-1.112.616.616,0,0,1,.944,0,.922.922,0,0,1,0,1.112A.592.592,0,0,1,6.658,15.552Zm0,4.4a.592.592,0,0,1-.472-.22.922.922,0,0,1,0-1.112.616.616,0,0,1,.944,0,.922.922,0,0,1,0,1.112A.592.592,0,0,1,6.658,19.949Zm0,4.4a.592.592,0,0,1-.472-.22.922.922,0,0,1,0-1.112.616.616,0,0,1,.944,0,.922.922,0,0,1,0,1.112A.592.592,0,0,1,6.658,24.346Z",
    transform: "translate(-6 -14)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.8e96ad7dc4d35c79e0b09f653bfbbd94.svg";
export { ForwardRef as ReactComponent };